var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MultiChoice = function (_a) {
    var _b;
    var execution = _a.execution, executeNodeOnUserInteraction = _a.executeNodeOnUserInteraction;
    var onChoiceSelected = function (edge) {
        execution.nodeId = execution.node.id;
        execution.isExecuted = true;
        execution.responseAction = [
            {
                id: edge.target,
                type: "CHOICES",
                data: JSON.stringify(edge.data),
            },
        ];
        executeNodeOnUserInteraction(execution);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsx("span", __assign({ className: "actual" }, { children: (_b = execution.node.data.formData) === null || _b === void 0 ? void 0 : _b.message })) })) })) })) })), _jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsx("ul", __assign({ className: "chat__messages-list multi_choice-list" }, { children: execution.relatedEdges.map(function (edge, index) {
                        var _a, _b;
                        return (_jsx("div", __assign({ className: "multi_choice-list-item-btn ".concat(execution.isExecuted ? 'disabled' : ''), onClick: function () { return onChoiceSelected(edge); } }, { children: _jsx("span", __assign({ className: "actual" }, { children: ((_a = edge.data) === null || _a === void 0 ? void 0 : _a.displayText) || ((_b = execution.node.data.formData.edgeOptions[index]) === null || _b === void 0 ? void 0 : _b.displayText) })) })));
                    }) })) })), execution.isExecuted && _jsx("div", __assign({ className: "chat__messages-group chat__messages-group--me" }, { children: _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsx("span", __assign({ className: "actual" }, { children: JSON.parse(execution.responseAction[0].data).displayText })) })) })) })) }))] }));
};
export default MultiChoice;
